import type { FlexProps } from '@ui/Flex';
import type { ReactNode } from 'react';

import useClassy from '@core/hooks/useClassy';
import Flex from '@ui/Flex';

import classes from './style.module.scss';

interface ModalFooterProps extends Pick<FlexProps, 'align' | 'gap' | 'justify'> {
  border?: boolean;
  children?: ReactNode;
  className?: string;
}

export default function ModalFooter({
  align,
  border = true,
  children,
  className,
  justify = 'end',
  ...attrs
}: ModalFooterProps) {
  const bem = useClassy(classes, 'Modal-Footer');

  return (
    <Flex
      align={align}
      className={bem('&', border && '_border', className)}
      gap="sm"
      justify={justify}
      tag="footer"
      {...attrs}
    >
      {children}
    </Flex>
  );
}
